module.exports = __webpack_public_path__ + "img/北京冷库1.71dd80f4.jpg";